module.exports = __webpack_public_path__ + "img/burger_white.d28bd7ce.svg";